import { IDropdownValue } from "./helpers";
import { ApprovalStatus } from "../types/approval-status/approval-status.type";
import { ReviewApprovalStatus } from "../types/review-approval/review-approval-status.type";
import { REVIEW_APPROVAL_STATUS } from "../types/review-approval/review-approval-status.enum";

export const HEADER_MIN_HEIGHT = 80;

export const RESULTS_PER_PAGE = 50;
export const PLACEHOLDER_PRODUCT_IMAGE_URL_40 = "https://via.placeholder.com/40x40?text=N/A";

// dropdown values for page statuses
export const DRAFT_PAGE_STATUS: IDropdownValue<ApprovalStatus> = {
  value: "draft",
  label: "Draft",
};
export const READY_FOR_APPROVAL_PAGE_STATUS: IDropdownValue<ApprovalStatus> = {
  value: "readyForApproval",
  label: "Ready for Approval",
};
export const IN_PROGRESS_PAGE_STATUS: IDropdownValue<ApprovalStatus> = {
  value: "in_progress",
  label: "In Progress",
};
export const APPROVED_PAGE_STATUS: IDropdownValue<ApprovalStatus> = {
  value: "approved",
  label: "Approved",
};
export const READY_FOR_CREATIVE_REVIEW: IDropdownValue<ApprovalStatus> = {
  value: "ready_for_creative_review",
  label: "Ready for Creative Review",
};
export const WORK_CAN_START: IDropdownValue<ApprovalStatus> = {
  value: "work_can_start",
  label: "Work Can Start",
};

// dropdown values for review stage statuses
export const NOT_READY_FOR_REVIEW: IDropdownValue<ReviewApprovalStatus> = {
  value: "not_ready_for_review",
  label: REVIEW_APPROVAL_STATUS.NOT_READY_FOR_REVIEW,
};
export const READY_FOR_REVIEW: IDropdownValue<ReviewApprovalStatus> = {
  value: "ready_for_review",
  label: REVIEW_APPROVAL_STATUS.READY_FOR_REVIEW,
};
export const REVIEW_NEEDS_UPDATING: IDropdownValue<ReviewApprovalStatus> = {
  value: "needs_updating",
  label: REVIEW_APPROVAL_STATUS.NEEDS_UPDATING,
};
export const REVIEW_APPROVED: IDropdownValue<ReviewApprovalStatus> = {
  value: "approved",
  label: REVIEW_APPROVAL_STATUS.APPROVED,
};

// Regex constants
export const REGEX_NO_CAPITAL_NO_WHITE_SPACE = "^[^A-Z\\s]*$";
